import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Component to protect routes that require authentication
const PrivateRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();

  const corporateToken = localStorage.getItem('corporateToken');
  const corporateMember = (() => {
    try {
      const raw = localStorage.getItem('corporateMember');
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  })();

  // Allow corporate staff to access regular user pages
  if (!user && corporateToken && corporateMember) {
    return children;
  }

  // If no user and not corporate, redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
